module.exports = __webpack_public_path__ + "70c46759dd0d74a5d55c8a440d0c554e.ttf";